/** Entitlements multi-tenant — /geo/v1/me e /geo/v1/branding. */

export interface ModuleEntitlement {
  key: string;
  nome: string;
  categoria: string;
  habilitado: boolean;
  cota: number | null;
}

export interface Branding {
  nome_exibicao: string;
  logo_url: string | null;
  cor_primaria: string;
  cor_marca: string;
  favicon_url: string | null;
  suporte_contato: string | null;
  subdominio: string | null;
}

export interface Me {
  user: { id: number; name: string; papel: string };
  tenant: { id: number; tipo: string; nome: string; status: string } | null;
  branding: Branding;
  limits: { device_limit: number; user_limit: number };
  modules: ModuleEntitlement[];
}

export const meApi = {
  get: async (): Promise<Me> => {
    const r = await fetch('/geo/v1/me', { credentials: 'include' });
    if (!r.ok) throw new Error(`me ${r.status}`);
    return r.json();
  },
  branding: async (): Promise<Branding> => {
    const r = await fetch('/geo/v1/branding', { credentials: 'include' });
    if (!r.ok) throw new Error(`branding ${r.status}`);
    return r.json();
  },
};
